// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1n5vm","content":"LoadingAlert_content__1GGFP"};